import { useState } from "react";

export default function SubscribeSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [msg, setMsg] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      setStatus("error");
      setMsg("请输入有效的邮箱地址");
      return;
    }
    // Simulate success - in real app would call get_form_url endpoint
    setStatus("success");
    setMsg("订阅成功！第一时间推送最新爆料");
    setEmail("");
  };

  return (
    <section className="bg-background-50 py-12 md:py-20" aria-label="订阅爆料推送">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
            不错过任何大瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            订阅独家爆料推送，热门大瓜第一时间直达
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-lg mx-auto mb-10"
        >
          <div className="hp-field">
            <input
              type="text"
              name="website_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
            />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setStatus("idle");
            }}
            placeholder="输入您的邮箱地址"
            className="w-full sm:flex-1 px-5 py-3 rounded-full bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400"
            required
          />
          <button
            type="submit"
            className="w-full sm:w-auto px-8 py-3 bg-foreground-800 text-white text-sm font-semibold rounded-full hover:bg-foreground-700 transition-colors whitespace-nowrap"
          >
            立即订阅
            <i className="ri-arrow-right-line ml-1" />
          </button>
        </form>

        {status !== "idle" && (
          <p
            className={`text-center text-sm mb-10 ${
              status === "success" ? "text-primary-600" : "text-primary-600"
            }`}
          >
            {msg}
          </p>
        )}

        {/* Image strip */}
        <div className="w-full h-32 md:h-48 rounded-xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Row%20of%20silhouetted%20celebrity%20figures%20and%20smartphone%20screens%20floating%20against%20dark%20background%2C%20social%20media%20gossip%20atmosphere%2C%20red%20and%20gold%20accent%20lighting%2C%20modern%20editorial%20illustration%20style&width=1400&height=400&seq=subscribe-strip&orientation=landscape"
            alt="明星剪影与社交媒体"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}